/**
 * @file index.tsx
 *
 * @fileoverview Shows a attachments for the organization.
 */

import React, { useContext } from 'react';

import { OrganizationProfile } from '~/jobiqo/types/types';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationAttachmentsWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/Attachments/Empty';
import { OrganizationAttachmentsWidgetView } from '~/jobiqo/components/Organization/Widgets/Attachments/View';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
const KEY = 'attachments';

export interface OrganizationAttachmentsWidgetProps {
  organization: OrganizationProfile;
}

export const OrganizationAttachmentsWidget = ({
  organization,
}: OrganizationAttachmentsWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (!organization.attachments || organization.attachments?.length === 0) {
    return userContext.user && organization.canEdit ? (
      <OrganizationAttachmentsWidgetEmpty
        organization={organization}
        boxId={KEY}
      />
    ) : null;
  } else {
    return (
      <OrganizationAttachmentsWidgetView
        organization={organization}
        boxId={KEY}
      />
    );
  }
};
export default OrganizationAttachmentsWidget;
